module.exports = "https://static.wmbcdn.com/uniweb/images/4ecf94a8fc16af37fdde5c034e8af81f.webp";